export const getInitials = (name: string) => {
    const names = name
        .trim()
        .split(' ')
        .filter(x => !!x);
    const size = names.length;
    if (size === 0) {
        return '';
    } else if (size === 1) {
        return names[0][0];
    }
    return `${names[0][0]}${names[size - 1][0]}`;
};
